import Char from "typescript-char";

const space: string = " ";
const empty: string = "";

export class Strings {

    public static get Empty(): string { return empty }
    public static get Space(): string { return space }

    public static truncate(target: string, length: number): string {
        return !!target && target.length > length ? target.slice(0, length - 3) + '...' : target;
    }

    public static trimEnd(target: string): string {
        return target.slice(0, -1);
    }

    public static newGuid(hyphens: boolean = true): string {
        let returnValue: string = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
            const randomNumber = Math.random() * 16 | 0, value = character === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8);
            return value.toString(16);
        });

        returnValue = hyphens ? returnValue : returnValue.replace(/-/g, Strings.Empty)
        return returnValue
    }

    public static trimTrailing(target: string, character: Char): string {
        const replaceCharacter = String.fromCharCode(character);
        const expression = new RegExp(`/\$${replaceCharacter}$/`);
        return target.replace(expression, Strings.Empty);
    }

    public static sanitizeUsername(value: string): string {
        return value.replace(/[!#$%&'*+\-\/=?^_`{|}~]/g, '');
    }

    public static padAround(value: string, maxLength: number, padCharacter: string = ' '): string {
        return value
            .padStart(value.length + Math.ceil((maxLength - value.length) / 2), padCharacter)
            .padEnd(maxLength, padCharacter)
    }

    public static isString(value: any): boolean {
        return Object.prototype.toString.call(value) === "[object String]"
    }

    public static titleCase(sentence: string): string {
        return sentence.split(Strings.Space)
            .map(([start, ...rest]) => `${start.toUpperCase()}${rest.join(Strings.Empty).toLowerCase()}`)
            .join(Strings.Space)
    }

    public static camelCase(sentence: string, separator: string = Strings.Space): string {
        let returnValue = Strings.titleCase(sentence)
        if (separator !== Strings.Space) {
            returnValue = returnValue.replaceAll(Strings.Space, separator)
        }
        return returnValue.length > 1 ? returnValue[0].toLowerCase() + returnValue.substring(1) : returnValue.toLowerCase()
    }
}

